import {
  CarInfoTable,
  CarInfoHeader,
  CarInfoCell,
} from "@app/components/InfoTable";
import { isOddEven, formatPercentFactor, formatNumber } from "@app/utils";
import { Fragment } from "react";
import { GrowthDataItem } from "./useSimulationModelsBoundaries";

export const SimulationModelsBoundariesGrowthDataTable = (props: {
  items: GrowthDataItem[];
}) => {
  return (
    <CarInfoTable sx={{ gridTemplateColumns: "0.5fr 1fr 1fr 1fr 1fr" }}>
      <CarInfoHeader text="" />
      <CarInfoHeader text="Lower Dollar Growth" />
      <CarInfoHeader text="Lower Compound Return" />
      <CarInfoHeader text="Upper Dollar Growth" />
      <CarInfoHeader text="Upper Compound Return" />
      {props.items.map((row, rowIdx) => (
        <Fragment key={rowIdx}>
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            justifyContent="start"
            text={`Year ${row.year}`}
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.lowerDollarGrowth
                ? formatNumber(row.lowerDollarGrowth, {
                    decimalPlaces: 6,
                  })
                : "-"
            }
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.lowerCompoundReturn
                ? formatNumber(row.lowerCompoundReturn, { decimalPlaces: 6 })
                : "-"
            }
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.upperDollarGrowth
                ? formatNumber(row.upperDollarGrowth, { decimalPlaces: 6 })
                : "-"
            }
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.upperCompoundReturn
                ? formatNumber(row.upperCompoundReturn, { decimalPlaces: 6 })
                : "-"
            }
          />
        </Fragment>
      ))}
    </CarInfoTable>
  );
};
